module.exports = __webpack_public_path__ + "gm992021/img/douluo-4.png?03967d95";